module.exports = __webpack_public_path__ + "img/183.98a1fa04.jpg";